// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var SmsMode$ReactHooksTemplate = require("./SmsMode.res.js");
var EmailMode$ReactHooksTemplate = require("./EmailMode.res.js");
var AppLinkMode$ReactHooksTemplate = require("./AppLinkMode.res.js");
var SmsLinkMode$ReactHooksTemplate = require("./SmsLinkMode.res.js");
var WebsiteLinkMode$ReactHooksTemplate = require("./WebsiteLinkMode.res.js");
var WhatsappLinkMode$ReactHooksTemplate = require("./WhatsappLinkMode.res.js");
var AnonymousLinkMode$ReactHooksTemplate = require("./AnonymousLinkMode.res.js");

function fromForm(form) {
  var emailForm = form.formMode;
  var mode;
  if (typeof emailForm !== "object") {
    mode = "Telephonic";
  } else {
    switch (emailForm.TAG) {
      case "Email" :
          mode = {
            TAG: "Email",
            _0: EmailMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "Sms" :
          mode = {
            TAG: "Sms",
            _0: SmsMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "SmsLink" :
          mode = {
            TAG: "SmsLink",
            _0: SmsLinkMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "WhatsappLink" :
          mode = {
            TAG: "WhatsappLink",
            _0: WhatsappLinkMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "AppLink" :
          mode = {
            TAG: "AppLink",
            _0: AppLinkMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "WebsiteLink" :
          mode = {
            TAG: "WebsiteLink",
            _0: WebsiteLinkMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      case "AnonymousLink" :
          mode = {
            TAG: "AnonymousLink",
            _0: AnonymousLinkMode$ReactHooksTemplate.fromForm(emailForm._0)
          };
          break;
      
    }
  }
  return {
          id: form.id,
          mode: mode
        };
}

function toForm(t) {
  var emailForm = t.mode;
  var formMode;
  if (typeof emailForm !== "object") {
    formMode = "Telephonic";
  } else {
    switch (emailForm.TAG) {
      case "Email" :
          formMode = {
            TAG: "Email",
            _0: EmailMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "Sms" :
          formMode = {
            TAG: "Sms",
            _0: SmsMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "SmsLink" :
          formMode = {
            TAG: "SmsLink",
            _0: SmsLinkMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "WhatsappLink" :
          formMode = {
            TAG: "WhatsappLink",
            _0: WhatsappLinkMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "AppLink" :
          formMode = {
            TAG: "AppLink",
            _0: AppLinkMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "WebsiteLink" :
          formMode = {
            TAG: "WebsiteLink",
            _0: WebsiteLinkMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      case "AnonymousLink" :
          formMode = {
            TAG: "AnonymousLink",
            _0: AnonymousLinkMode$ReactHooksTemplate.toForm(emailForm._0)
          };
          break;
      
    }
  }
  return {
          id: t.id,
          formMode: formMode
        };
}

function modeType(t) {
  var anm = t.mode;
  if (typeof anm !== "object") {
    return "Telephonic";
  }
  switch (anm.TAG) {
    case "Email" :
        return EmailMode$ReactHooksTemplate.modeType;
    case "Sms" :
        return SmsMode$ReactHooksTemplate.modeType;
    case "SmsLink" :
        return SmsLinkMode$ReactHooksTemplate.modeType;
    case "WhatsappLink" :
        return WhatsappLinkMode$ReactHooksTemplate.modeType;
    case "AppLink" :
        return AppLinkMode$ReactHooksTemplate.modeType;
    case "WebsiteLink" :
        return WebsiteLinkMode$ReactHooksTemplate.modeType;
    case "AnonymousLink" :
        return AnonymousLinkMode$ReactHooksTemplate.modeType(anm._0);
    
  }
}

function encoder(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  console.log("t", t);
  var email = t.mode;
  var tmp;
  if (typeof email !== "object") {
    tmp = {
      hd: [
        "id",
        Json_encode.nullable((function (prim) {
                return prim;
              }), t.id)
      ],
      tl: {
        hd: [
          "mode_type",
          "Telephonic"
        ],
        tl: {
          hd: [
            "mode_attributes",
            Json_encode.object_(/* [] */0)
          ],
          tl: {
            hd: [
              "_destroy",
              destroy
            ],
            tl: /* [] */0
          }
        }
      }
    };
  } else {
    switch (email.TAG) {
      case "Email" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                EmailMode$ReactHooksTemplate.modeType
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  EmailMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "Sms" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                "Sms"
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  SmsMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "SmsLink" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                SmsLinkMode$ReactHooksTemplate.modeType
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  SmsLinkMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "WhatsappLink" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                WhatsappLinkMode$ReactHooksTemplate.modeType
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  WhatsappLinkMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "AppLink" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                AppLinkMode$ReactHooksTemplate.modeType
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  AppLinkMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "WebsiteLink" :
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                WebsiteLinkMode$ReactHooksTemplate.modeType
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  WebsiteLinkMode$ReactHooksTemplate.encoder(email._0)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      case "AnonymousLink" :
          var anonymousLink = email._0;
          tmp = {
            hd: [
              "id",
              Json_encode.nullable((function (prim) {
                      return prim;
                    }), t.id)
            ],
            tl: {
              hd: [
                "mode_type",
                AnonymousLinkMode$ReactHooksTemplate.modeType(anonymousLink)
              ],
              tl: {
                hd: [
                  "mode_attributes",
                  AnonymousLinkMode$ReactHooksTemplate.encoder(anonymousLink)
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            }
          };
          break;
      
    }
  }
  return Json_encode.object_(tmp);
}

function decoder(json) {
  var modeType = Json_decode.field("mode_type", Json_decode.string, json);
  if (modeType === EmailMode$ReactHooksTemplate.modeType) {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "Email",
              _0: Json_decode.field("mode", EmailMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === SmsLinkMode$ReactHooksTemplate.modeType) {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "SmsLink",
              _0: Json_decode.field("mode", SmsLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === WhatsappLinkMode$ReactHooksTemplate.modeType) {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "WhatsappLink",
              _0: Json_decode.field("mode", WhatsappLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === "AnonymousLink") {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "AnonymousLink",
              _0: Json_decode.field("mode", AnonymousLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === "Sms") {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "Sms",
              _0: Json_decode.field("mode", SmsMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === "Telephonic") {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: "Telephonic"
          };
  } else if (modeType === "WebsiteLink") {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "WebsiteLink",
              _0: Json_decode.field("mode", WebsiteLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else if (modeType === "QrCode") {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "AnonymousLink",
              _0: Json_decode.field("mode", AnonymousLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  } else {
    return {
            id: Json_decode.field("id", (function (param) {
                    return Json_decode.optional(Json_decode.$$int, param);
                  }), json),
            mode: {
              TAG: "AppLink",
              _0: Json_decode.field("mode", AppLinkMode$ReactHooksTemplate.decoder, json)
            }
          };
  }
}

exports.fromForm = fromForm;
exports.toForm = toForm;
exports.modeType = modeType;
exports.encoder = encoder;
exports.decoder = decoder;
/* No side effect */
